"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Avatar = exports.testIds = exports.AvatarType = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const silhouette_core_1 = require("@freighthub/silhouette-core");
const AvatarUtil_1 = require("./AvatarUtil");
var AvatarType;
(function (AvatarType) {
    AvatarType["FORTO_AVATAR"] = "forto-avatar";
    AvatarType["INITIALS_AVATAR"] = "initials-avatar";
    AvatarType["THUMBNAIL_AVATAR"] = "thumbnail_url-avatar";
})(AvatarType || (exports.AvatarType = AvatarType = {}));
const sizeMap = {
    small: { size: 24, variant: 'body3-medium' },
    medium: { size: 32, variant: 'body2-medium' },
    large: { size: 40, variant: 'body2-medium' },
};
const getDimensions = (size) => ({ height: size, width: size });
exports.testIds = {
    fortoLogo: 'avatar-forto_avatar',
};
const Avatar = ({ avatar, avatarType, className = '', 'data-testid': testId, fullName, userType = 'default', size = 'medium', }) => {
    const dataTestId = testId || avatarType;
    const theme = (0, silhouette_core_1.useTheme)();
    const userTypeStyleConfig = {
        customer: {
            bgcolor: theme.palette.highlight.dark,
            color: theme.palette.common.white,
        },
        fortie: {
            bgcolor: theme.palette.primary.main,
            color: theme.palette.common.white,
        },
        default: {
            bgcolor: theme.palette.header.background,
            color: theme.palette.common.white,
        },
    };
    const dimensions = getDimensions(sizeMap[size].size);
    const userName = fullName || avatar;
    if (avatarType === AvatarType.INITIALS_AVATAR) {
        return ((0, jsx_runtime_1.jsx)(silhouette_core_1.Avatar, { className: className, "data-testid": dataTestId, sx: { ...userTypeStyleConfig[userType], ...dimensions }, children: (0, jsx_runtime_1.jsx)(silhouette_core_1.Typography, { color: "inherit", variant: "body2-medium", children: (0, AvatarUtil_1.getAvatarInitials)(userName) }) }));
    }
    if (avatarType === AvatarType.THUMBNAIL_AVATAR) {
        return (0, jsx_runtime_1.jsx)(silhouette_core_1.Avatar, { className: className, "data-testid": dataTestId, src: avatar, alt: userName, sx: dimensions });
    }
    return ((0, jsx_runtime_1.jsx)(silhouette_core_1.Avatar, { className: className, "data-testid": dataTestId, sx: { ...userTypeStyleConfig.default, ...dimensions }, children: (0, jsx_runtime_1.jsx)(silhouette_core_1.FortoLogoLightIcon, { fontSize: "small", "data-testid": exports.testIds.fortoLogo }) }));
};
exports.Avatar = Avatar;
//# sourceMappingURL=Avatar.js.map